import { Toaster } from "react-hot-toast";
import BackButtonWrapper from "../../components/button/BackButton/wrapper";
import { useTranslation } from "react-i18next";
import { PAGE_SIZE } from "../../constants/common";
import EvacuationEventsTable from "../../components/table/EvacuationEventsTable";
import { useState } from "react";
import SearchEvacuationEventsCard from "../../components/card/SearchEvacuationEventsCard";
import Loader from "../../components/loader";

const EvacuationEvents = () => {
  const { t } = useTranslation();

  const [page, setPage] = useState<number>(1);
  const [pages, setPages] = useState(1);
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState<number>(PAGE_SIZE);
  const [search, setSearch] = useState("");

  const [allEvacuationEvents, setAllEvacuationEvents] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />

      <div className="flex flex-col gap-4 md:gap-8">
        <BackButtonWrapper>
          <h1 className="text-xl md:text-2xl dark:text-white">
            {t("evacuationEvents")}
          </h1>
        </BackButtonWrapper>

        <SearchEvacuationEventsCard
          setAllEvacuationEvents={setAllEvacuationEvents}
          setIsLoading={setIsLoading}
          page={page}
          setPages={setPages}
          setPage={setPage}
          search={search}
          setCount={setCount}
          pageSize={pageSize}
        />
        {isLoading ? (
          <div className="flex justify-center">
            <Loader />
          </div>
        ) : (
          <EvacuationEventsTable
            allEvacuationEvents={allEvacuationEvents}
            page={page}
            pages={pages}
            setPage={setPage}
            search={search}
            setSearch={setSearch}
            count={count}
            pageSize={pageSize}
            setPageSize={setPageSize}
          />
        )}
      </div>
    </>
  );
};

export default EvacuationEvents;
